import React, { useState } from "react";
import style from "./NewsLetter.module.css";
import "./NewsLetter.css";
import cx from "classnames";
export default function NewsLetter({ display, imgSrc }) {
  const initState = {
    name: "",
    email: "",
  };
  const [data, setData] = useState(initState);
  return (
    <div className={cx(style.mainContainer, display)}>
      <div id="imageContainer" className={cx(style.imageContainer, display)}>
        <img src={imgSrc} className={cx(style.fig, display)} alt=""></img>
      </div>
      <div id="formDiv" className={cx(style.formContainer, display)}>
        <p className={cx(style.heading, display)}>
          SUBSCRIBE TO OUR NEWSLETTER
        </p>
        <form className={display}>
          <input
            className={cx(style.input, display)}
            value={data.name}
            onChange={e => setData({ ...data, name: e.target.value })}
            placeholder=" Name"
          ></input>
          <input
            className={cx(style.input, display)}
            value={data.email}
            onChange={e => setData({ ...data, email: e.target.value })}
            placeholder=" Email Address"
          ></input>

          <button type="submit" className={cx(style.subBtn, display)}>
            Subscribe
          </button>
        </form>
      </div>
    </div>
  );
}
